"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.broadcastProviderActions = void 0;
const toolkit_1 = require("../../utils/@reduxjs/toolkit");
const constants_1 = require("./constants");
const REDUCER_KEY = 'broadcastProvider';
const slice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: constants_1.initialState,
    reducers: {
        fetchBroadcastsAvailability(state, _action) {
            state.fetchItems.loading = true;
            state.fetchItems.error = null;
        },
        fetchBroadcastsAvailabilitySuccess(state, action) {
            const { items } = action.payload.resData;
            items.forEach((broadcastAvailability) => {
                state.broadcastsAvailabilityMapping[broadcastAvailability.eventId] =
                    broadcastAvailability;
            });
            state.fetchItems.loading = false;
            state.fetchItems.error = null;
        },
        fetchBroadcastsAvailabilityError(state, action) {
            state.fetchItems.loading = false;
            state.fetchItems.error = action.payload;
        },
        fetchBroadcast(state, _action) {
            state.fetchItem.loading = true;
            state.fetchItem.error = null;
        },
        fetchBroadcastSuccess(state, action) {
            const broadcast = action.payload.resData;
            state.broadcasts[broadcast.eventId] = broadcast;
            state.fetchItem.loading = false;
            state.fetchItem.error = null;
        },
        fetchBroadcastError(state, action) {
            state.fetchItem.loading = false;
            state.fetchItem.error = action.payload;
        },
    },
});
exports.broadcastProviderActions = slice.actions, exports.reducer = slice.reducer, exports.sliceKey = slice.name;
//# sourceMappingURL=slice.js.map